// 'base' takes 'M' or 'P', means 'metric' or 'programmer'
function _formatBytes (base, bytes, decimals) {
    if (typeof bytes !== 'number') return '';
    if (bytes < 0) return '';
    bytes = Math.round(bytes);
    if (bytes === 0) return '0 B';

    // 'M' (metric) is default
    // http://2ality.com/2014/06/es6-multiple-return-values.html
    const [c, e] = (function () {
        return base === 'P'
            ? [1024, ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']]
            : [1000, ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']];
    })();

    const d = decimals || 2;
    const f = Math.floor(Math.log(bytes) / Math.log(c));
    // not really a googol but close enough for us.
    if (f >= e.length) return 'googol';
    return parseFloat((bytes / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
}

// tooltips for units of bits
const FormatBits = function (bits, decimals) {
    if (typeof bits !== 'number') return '';
    if (bits < 0) return '';
    bits = Math.round(bits);
    if (bits === 0) return '0 b';

    // 'M' (metric) is default
    // http://2ality.com/2014/06/es6-multiple-return-values.html
    const [c, e] = (() => [1000, ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb']])();

    const d = decimals || 2;
    const f = Math.floor(Math.log(bits) / Math.log(c));
    // not really a googol but close enough for us.
    if (f >= e.length) return 'googol';
    return parseFloat((bits / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
};

// metric
const FormatBytesM = (bytes, decimals) => _formatBytes('M', bytes, decimals);
// Programmer's
const FormatBytesP = (bytes, decimals) => _formatBytes('P', bytes, decimals);

const Bytes = function (input, decimals, programmer) {
    switch (typeof input) {
        case 'number': // fall-through
        // optimistically assume number in string representation
        case 'string':
            return programmer ? FormatBytesP(+input, decimals) : FormatBytesM(+input, decimals);
    }
    return input;
};

export { Bytes, FormatBytesM, FormatBytesP, FormatBits };
